
export const LanguageEnum = {
  hy: 1,
  ru: 2,
  en: 3,

  1: 'hy',
  2: 'ru',
  3: 'en',
}